<script setup>
import { computed } from 'vue';
import { cn } from '@/lib/utils';

const emit = defineEmits(['update:checked']);

const props = defineProps({
    checked: {
        type: [Array, Boolean],
        default: false,
    },
    value: {
        type: String,
        default: null,
    },
    indeterminate: {
        type: Boolean,
        default: false,
    },
    class: {
        type: [String, Array, Object],
        default: '',
    },
});

const proxyChecked = computed({
    get() {
        return props.checked;
    },

    set(val) {
        emit('update:checked', val);
    },
});
</script>

<template>
    <input
        v-model="proxyChecked"
        type="checkbox"
        :value="value"
        :indeterminate="indeterminate"
        :class="cn('rounded border-gray-300 text-brand shadow-sm focus:ring-brand', props.class)"
    />
</template>
